import React from "react";
import { MCheckbox, MRadioButton, ValidatedForm } from "components/forms";
import { Button } from "design-react-kit";
import { TitoliProfessionaliTFAIndire } from "./TitoliProfessionaliTFAIndire";
import { dateHelper } from "libs";

export class TitolareContrattoTFAIndire extends ValidatedForm {
  _formsContrattoDocenza = [];

  state = {
    dichiarazione75: false,
    dichiarazione77: "",
    numContrattoDocenza: [],
    validationError: "",
  };

  componentDidMount() {
    this.initializeFromPayload();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.defaultPayload !== this.props.defaultPayload) {
      this.initializeFromPayload();
    }
  }

  initializeFromPayload = () => {
    const { defaultPayload, courseType } = this.props;
    const contrattiDocenza = defaultPayload;

    if (courseType === "75") {
      if (contrattiDocenza && contrattiDocenza.length > 0) {
        this.setState({
          dichiarazione75: true,
          numContrattoDocenza: contrattiDocenza,
        });
      }
    } else if (courseType === "77") {
      const hasContratti = contrattiDocenza.length > 0;

      this.setState({
        dichiarazione77: hasContratti ? "2" : "1",
        numContrattoDocenza: contrattiDocenza,
      });
    }
  };

  addContrattoDocenza = () => {
    this.state.numContrattoDocenza.push(this.state.numContrattoDocenza.length + 1);
    this.setState({
      ...this.state,
      numContrattoDocenza: this.state.numContrattoDocenza,
    });
  };

  removeContrattoDocenza = (idx) => {
    if (this.state.numContrattoDocenza.length <= 0) {
      return true;
    }

    this.state.numContrattoDocenza.splice(idx, 1);
    this._formsContrattoDocenza.splice(idx, 1);

    this.setState({
      ...this.state,
      numContrattoDocenza: this.state.numContrattoDocenza,
    });
  };

  checkAnniEsperienza(payloadToCheck) {
    /* 
     75: min 3 annualità, max 8

     77: se flaggata l'opzione 2, è sufficiente che il candidato indichi una sola annualità
     di servizio valida [180 gg (anche con più servizi distinti nel medesimo anno scolastico)
     o fino al termine del…].

    */

    let validationError = "";
    const { courseType } = this.props;

    if (payloadToCheck.length > 0) {
      // 1. lista degli anni in cui si è svolto servizio
      let yearServices = [];

      for (let i = 0; i < payloadToCheck.length; i++) {
        const item = payloadToCheck[i];
        if (item.aa && !yearServices.includes(item.aa)) {
          yearServices.push(item.aa);
        }
      }

      // 2. per ogni aa in cui si è svolto il servizio si calcolano i giorni
      // lavorativi
      let yearResume = [];
      for (let i = 0; i < yearServices.length; i++) {
        const aa = yearServices[i];
        const aaItems = payloadToCheck.filter((t) => t.aa === aa);

        // order aaItems by dateFrom ASC
        aaItems.sort((a, b) => {
          return a.dateFrom - b.dateFrom;
        });

        let totalAADays = 0;

        for (let j = 0; j < aaItems.length; j++) {
          const aaItem = aaItems[j];

          // if lode add 180 days and skip this year
          if (aaItem.lode) {
            totalAADays += 180;
            break;
          }

          let durata = parseInt(aaItem.durata) || 0;

          // verifica se il periodo corrente ha delle intersezioni con il precedente
          if (j > 0) {
            const prevItem = aaItems[j - 1];
            if (aaItem.dateFrom <= prevItem.dateTo) {
              // rimuove l'intersezione dal calcolo dei giorni
              const intersecation = dateHelper.diffDays(prevItem.dateTo, aaItem.dateFrom);
              durata -= intersecation;
            }
          }

          totalAADays += durata;
        }

        yearResume.push({ aa: aa, totalAADays });
      }

      let validYears = 0;

      // Conta annualità valide (almeno 180 giorni)
      for (let i = 0; i < yearResume.length; i++) {
        const year = yearResume[i];

        if (year.totalAADays >= 180) {
          validYears++;
        }
      }

      // 4. Validazione finale
      if (courseType === "75") {
        if (validYears < 3) {
          validationError = "Almeno tre anni di servizio devono essere stati svolti per partecipare alla graduatoria.";
        } else if (validYears > 8) {
          validationError = "È possibile dichiarare un massimo di 8 annualità di servizio.";
        }
      } else if (courseType === "77") {
        if (validYears < 1) {
          validationError = "È necessario indicare almeno un'annualità di servizio valida.";
        }
      }
    } else {
      validationError = "È necessario aggiungere i servizi prestati.";
    }

    return validationError;
  }

  getPayload = () => {
    const payloadTitles = [];
    const isSubformActive = this.isSubformActive();

    if (isSubformActive) {
      this._formsContrattoDocenza.forEach((form) => {
        if (form && form.current != null) {
          // get payload
          const payload = form.current.getPayload();
          payloadTitles.push(payload);
        }
      });
    }

    return payloadTitles;
  };

  onSubmit = () => {
    let validationError = "";
    let isValid = true;
    const { courseType } = this.props;
    const { dichiarazione75, dichiarazione77 } = this.state;

    if (courseType === "75" && !dichiarazione75) {
      this.setState({
        validationError: "Selezionare la dichiarazione e aggiungere i requisiti professionali.",
      });
      return false;
    } else if (courseType === "77" && dichiarazione77 === "") {
      this.setState({
        validationError: "Selezionare una delle due opzioni",
      });
      return false;
    }

    if (this.isSubformActive()) {
      const payloadToCheck = [];

      if (this._formsContrattoDocenza.length > 0) {
        this._formsContrattoDocenza.forEach((form) => {
          if (form && form.current !== null) {
            const valid = form.current.onSubmit();
            if (!valid) {
              isValid = false;
              validationError = "Inserire i dati richiesti.";
            } else {
              const payload = form.current.getPayload();
              payloadToCheck.push(payload);
            }
          }
        });

        if (isValid) {
          validationError = this.checkAnniEsperienza(payloadToCheck);
          if (validationError) {
            isValid = false;
          }
        }
      } else {
        isValid = false;
        validationError = "Inserire i dati richiesti.";
      }
    } else {
      isValid = true;
      validationError = "";
    }

    this.setState({ validationError: validationError });
    return isValid;
  };

  onChangeField = (field, value) => {
    this.setState({ [field]: value, validationError: "" }, () => {
      // reset subforms if unchecked
      if (!this.isSubformActive()) {
        this.setState({ numContrattoDocenza: [] });
        this._formsContrattoDocenza = [];
      }
    });
  };

  isSubformActive = () => {
    const { courseType } = this.props;
    const { dichiarazione75, dichiarazione77 } = this.state;

    if (courseType === "75") {
      return dichiarazione75 === true;
    }
    if (courseType === "77") {
      return dichiarazione77 === "2";
    }
    return false;
  };

  render() {
    const { validationError, numContrattoDocenza, dichiarazione75, dichiarazione77 } = this.state;
    const { qualificationType, courseType, competitionClass, grado } = this.props;

    const showSubform = this.isSubformActive();

    return (
      <>
        {courseType === "75" && (
          <MCheckbox
            id="dichiarazione75"
            name="dichiarazione75"
            field="dichiarazione75"
            label="Dichiaro di aver prestato il seguente servizio presso le istituzioni scolastiche statali o presso le scuole paritarie per almeno tre anni, anche non continuativi, di cui almeno uno nella specifica classe di concorso per la quale scelgo di conseguire l’abilitazione nei cinque anni precedenti, valutati ai sensi dell'art. 11, comma 14, della Legge 3 maggio 1999, n. 124."
            className="col-md-12"
            value={dichiarazione75}
            onChange={this.onChangeField}
          />
        )}

        {courseType === "77" && (
          <MRadioButton
            id="dichiarazione77"
            name="dichiarazione77"
            field="dichiarazione77"
            payload={{
              options: [
                {
                  value: "1",
                  label:
                    "Dichiaro di non aver svolto, nelle istituzioni scolastiche statali e paritarie, servizio su posto di sostegno nel grado specifico di cui alla domanda di ammissione, della durata di almeno un anno scolastico, nel rispetto di quanto previsto dalla normativa vigente.",
                },
                {
                  value: "2",
                  label:
                    "Dichiaro di aver svolto, nelle istituzioni scolastiche statali e paritarie, servizio su posto di sostegno, nel grado specifico di cui alla domanda di ammissione, della durata di almeno un anno scolastico nel rispetto di quanto previsto dalla normativa vigente.",
                },
              ],
            }}
            value={dichiarazione77}
            className="col-md-12"
            onChange={this.onChangeField}
          />
        )}

        {showSubform && (
          <div>
            {(numContrattoDocenza || []).map((payload, idx) => {
              this._formsContrattoDocenza[idx] = React.createRef();

              return (
                <div key={`contrattoDocenza=${idx}`} className="m-0 ml-5 mt-5 text-secondary">
                  <h6>Servizio n. {idx + 1}</h6>
                  <Button
                    className="mb-3 btn btn-sm btn-danger"
                    onClick={() => {
                      this.removeContrattoDocenza(idx);
                    }}
                  >
                    Rimuovi
                  </Button>
                  <div className="p-3 border border-secondary rounded-lg">
                    <TitoliProfessionaliTFAIndire
                      ref={this._formsContrattoDocenza[idx]}
                      key={`contrattoDocenza=${idx}`}
                      idx={idx}
                      defaultValues={typeof payload === "number" ? {} : payload}
                      grado={grado}
                      competitionClass={competitionClass}
                      qualificationType={qualificationType}
                      qualificationCode={qualificationType + "_TitolareContratto"}
                      template={qualificationType + "_TITOLARE_CONTRATTO"}
                      extCode="TITOLARE_CONTRATTO"
                      courseType={courseType}
                    />
                  </div>
                </div>
              );
            })}
            <div className="mt-3 ml-5 text-secondary">
              <Button className="btn btn-sm btn btn-secondary" onClick={this.addContrattoDocenza}>
                Aggiungi
              </Button>
            </div>
          </div>
        )}
        {validationError && <div className="text-danger">{validationError}</div>}
      </>
    );
  }
}
